import { useCallback, useMemo, useState } from "react";

import type { ExpertAssistMessage } from "../../shared-types";

import { isProactiveGuidanceType } from "../../utils/isFromBot";

export function useProactiveGuidanceHistory(messages: ExpertAssistMessage[]) {
    const guidanceMessages = useMemo(
        () => messages.filter((message) => isProactiveGuidanceType(message.type) && message.status === "active"),
        [messages],
    );
    const latestId = guidanceMessages.at(-1)?.id;
    const lastIndex = Math.max(guidanceMessages.length - 1, 0);
    const [viewedIndex, setViewedIndex] = useState(lastIndex);
    const [trackedLatestId, setTrackedLatestId] = useState(latestId);

    if (latestId !== trackedLatestId) {
        setTrackedLatestId(latestId);
        setViewedIndex(lastIndex);
    } else if (viewedIndex > lastIndex) {
        setViewedIndex(lastIndex);
    }

    const setPage = useCallback(
        (page: number) => {
            setViewedIndex(Math.min(Math.max(page - 1, 0), lastIndex));
        },
        [lastIndex],
    );

    return {
        guidanceMessages,
        currentMessage: guidanceMessages[viewedIndex],
        shouldShowNav: guidanceMessages.length > 1,
        page: viewedIndex + 1,
        total: guidanceMessages.length,
        setPage,
    };
}
